module.exports = __webpack_public_path__ + "static/media/my-account-bg.57752e7a.jpg";